export const editMenu = {
	menuActive: "Activar menú",
	goBack: "Volver a todos los menús",
	deleteConfirm: "¿Está seguro que desea eliminar el menú?",
	okText: "¡Sí, quiero!",
	warningNotification:
		"Menú editado, pero hubo un problema en el registro del horario de funcionamiento:",
	errorProductIdentify:
		"no fue posible identificar el producto correspondiente de {{name}}, descargue una nueva hoja de cálculo modelo y tenga cuidado con la columna 'identificador'",
	successNotification: "La información de todos los productos fue editada con éxito",
	errorEditNotification: "Error en ",
	updatedPrices: "Precios actualizados",
	search: "Buscar productos",
	massEdit: "Editar productos en masa",
	deleteProducts: "Eliminar productos",
	deleteProductsConfirm:
		"¿Está seguro que desea eliminar todos los productos seleccionados del menú?",
	massDelete: "Eliminar productos en masa",
	add: "Agregar producto",
};
